var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loadingStatus
    ? _c("div", { staticClass: "spinnerTop" }, [
        _c("div", { staticClass: "spinner" }, [
          _c("svg", { attrs: { viewBox: "0 0 64 64" } }, [
            _c("g", { attrs: { "stroke-width": "0" } }, [
              _c(
                "circle",
                {
                  attrs: {
                    cx: "24",
                    cy: "0",
                    transform: "translate(32,32)",
                    r: "6.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "8;7;6;5;4;3;2;1;8",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "16.970562748477143",
                    cy: "16.97056274847714",
                    transform: "translate(32,32)",
                    r: "7.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "1;8;7;6;5;4;3;2;1",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "1.4695761589768238e-15",
                    cy: "24",
                    transform: "translate(32,32)",
                    r: "3.57921",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "2;1;8;7;6;5;4;3;2",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "-16.97056274847714",
                    cy: "16.970562748477143",
                    transform: "translate(32,32)",
                    r: "3.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "3;2;1;8;7;6;5;4;3",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "-24",
                    cy: "2.9391523179536475e-15",
                    transform: "translate(32,32)",
                    r: "3.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "4;3;2;1;8;7;6;5;4",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "-16.970562748477143",
                    cy: "-16.97056274847714",
                    transform: "translate(32,32)",
                    r: "3.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "5;4;3;2;1;8;7;6;5",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "-4.408728476930472e-15",
                    cy: "-24",
                    transform: "translate(32,32)",
                    r: "4.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "6;5;4;3;2;1;8;7;6",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
              _c(
                "circle",
                {
                  attrs: {
                    cx: "16.970562748477136",
                    cy: "-16.970562748477143",
                    transform: "translate(32,32)",
                    r: "5.63154",
                  },
                },
                [
                  _c("animate", {
                    attrs: {
                      attributeName: "r",
                      dur: "800ms",
                      values: "7;6;5;4;3;2;1;8;7",
                      repeatCount: "indefinite",
                    },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }